import { Box } from '@mui/material';

import { getFlowTemplateCardColors } from './colors';

interface FlowTemplateCardDecorationProps {
  solutionArea?: string;
}

export function FlowTemplateCardDecoration(props: FlowTemplateCardDecorationProps) {
  const { solutionArea } = props;
  const colors = getFlowTemplateCardColors({ solutionArea });
  return (
    <Box
      sx={{
        width: '100%',
        height: 12,
        background: `linear-gradient(to right, ${colors.dark}, ${colors.light})`,
      }}
    />
  );
}
